import { BreadcrumbSchema } from "@/components/common/Seo/BreadcrumbSchema"
import type { CategoryArchiveProps } from "@/components/resources/data/archives"
import { RESOURCE_CATEGORIES } from "@/components/resources/data/markdown/categories"
import { BASE_BLOG_PATH } from "@/constants/urls"
import { CategoryArchive } from "./CategoryArchive"

/** A page of a /resources/[category] archive */
export const ResourceCategoryArchive = (props: CategoryArchiveProps) => (
  <>
    <CategoryArchive {...props} />
    <BreadcrumbSchema
      items={[
        { name: "Resources", path: BASE_BLOG_PATH },
        {
          // The same name as in a post's breadcrumbs
          name: RESOURCE_CATEGORIES[props.category].categoryName,
          path: `${BASE_BLOG_PATH}/${props.category}`,
        },
      ]}
    />
  </>
)
